// generated by genversion
const version = '6.15.5';

export { version };
//# sourceMappingURL=version.mjs.map
